<template>
    <div class="prof-edit-details content-container">
        <div class="header">
            <div class="title">Your Details</div>
        </div>        
        <div class="content form-content">
            <h2>Basic Info</h2>
            <div class="edit-row">
                <div class="caption">First Name</div>
                <input v-model="firstName" />
            </div>
            <div class="edit-row">
                <div class="caption">Last Name</div>
                <input v-model="lastName" />
            </div>
            <div class="edit-row">
                <div class="caption">Email</div>
                <input v-model="email" />
            </div>
            <h2>Password change</h2>
            <div class="edit-row">
              <div class="caption">Current Password</div>
              <input type="password" v-model="currentPassword">
            </div>
            <div class="edit-row">
              <div class="caption">New Password</div>
              <input type="password" v-model="newPassword">
            </div>
            <div class="edit-row">
              <div class="caption">Confirm New Password</div>
              <input type="password" v-model="confirmNewPassword">
            </div>
            <div class="edit-row">
              <button class="send-to-right" @click="changePassword">Change Password</button>
              <span class="password-error send-to-right">{{passwordError}}</span>
              <span class="password-message send-to-right">{{passwordMessage}}</span>
            </div>
            <h2>Location</h2>
            <div class="edit-row">
                <div class="caption">Country</div>
                <input v-model="country" />
            </div>
            <div class="edit-row">
                <div class="caption">State/Province</div>
                <input v-model="stateProvince" />
            </div>
            <div class="edit-row">
                <div class="caption">City</div>
                <input v-model="city" />
            </div>       
            <div class="edit-row">
                <div class="caption">Show Publicly?</div>    
                <input type="checkbox" v-model="showLocation" />
            </div>             
            
            <h2>Misc</h2>
            <div class="edit-row">
                <div class="caption">Website</div>
                <input v-model="website" />
            </div>
            <div class="edit-row">
                <div class="caption">Interests</div>
                <input v-model="interests" />
            </div>
            <div class="edit-row">
                <div class="caption">Avatar</div>
                <input style="display:none;" type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                <div class="send-to-right">
                  <img class="send-to-right" :src="details.avatarUrl" alt="avatar"/>
                  <br/>
                  <button @click="changeAvatar">Change Avatar</button>
                  <div>{{newAvatarName}}</div>
                </div>
                
            </div>
        </div>
        <div class="footer">
            <div class="footer-right">
                <button v-on:click="cancelDetails" >Cancel</button>
                <button v-on:click="submitDetails">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
    
    import api from '../../api/api'
    import dialogs from '../../modules/dialogs';

    export default {

        props: ['details'],
        components: {
        },
        data() {
            return {
                firstName: null,
                currentPassword: null,
                newPassword: null,
                confirmNewPassword: null,
                passwordError: null,
                lastName: null,
                email: null,
                country: null,
                stateProvince: null,
                city: null,
                passwordMessage: null,
                showLocation: false,                
                website: null,
                interests: null,
                avatar: null,
                originalDetails: {
                    firstName: null,
                    lastName: null,
                    email: null,
                    country: null,
                    stateProvince: null,
                    city: null,
                    showLocation: false,
                    website: null,
                    interests: null,
                    avatar: null,
                }
            }            
        },
        computed:{
          newAvatarName() {
            if(!this.avatar) {
              return null;
            }
            return this.avatar.name;
          },
        },
        methods: {
          changeAvatar() {
            this.$refs.file.click();
          },
          handleFileUpload() {
            this.avatar = this.$refs.file.files[0];
          },
          changePassword() {
            this.passwordError = "";
            this.passwordMessage = "";
            if(this.newPassword !== this.confirmNewPassword) {
              this.passwordError = "New password and confirmation do not match";
              return;
            }
            api.auth('/changePassword', {
              CurrentPassword: this.currentPassword,
              NewPassword: this.newPassword
            }).then(() => {
              this.currentPassword = "";
              this.newPassword = ""
              this.confirmNewPassword = "";
              this.passwordMessage = "Success";
            }).catch((error) => {
              this.currentPassword = "";
              this.newPassword = ""
              this.confirmNewPassword = "";
              this.passwordError = error.response.data.message;
            })
          },
            submitDetails: function() {

                let data = {};

                data.memberID = parseInt(this.details.id);
                data.firstName = this.firstName
                data.lastName = this.lastName
                data.email = this.email
                data.country = this.country
                data.stateProvince = this.stateProvince
                data.city = this.city
                data.showLocation = this.showLocation
                data.website = this.website
                data.interests = this.interests

                api.post('/members/' + this.details.id, data)
                    .then(async (response) => {
                        if (response.data.success === true) {

                            this.originalDetails.firstName = this.firstName;
                            this.originalDetails.lastName = this.lastName;
                            this.originalDetails.email = this.email;
                            this.originalDetails.country = this.country;
                            this.originalDetails.stateProvince = this.stateProvince;
                            this.originalDetails.city = this.city;
                            this.originalDetails.showLocation = this.showLocation;
                            this.originalDetails.website = this.website;
                            this.originalDetails.interests = this.interests;

                            if(this.avatar) {
                              var formData = new FormData();
                              var imagefile = this.avatar;
                              formData.append("image", imagefile);

                              await api.post('/members/changeAvatar',formData ,{
                                  headers: {
                                    'Content-Type': 'multipart/form-data'
                                  }});
                            }
                            location.reload();
                        } else {
                            await dialogs.alertAsync(response.data.message);
                        }
                    }
                ).catch(async (error) => {
                  await dialogs.alertAsync(error);
                });
            },
            async cancelDetails() {
                if(await dialogs.confirmAsync("Are you sure you want to cancel edits to your details?")) {
                    this.firstName = this.originalDetails.firstName;
                    this.lastName = this.originalDetails.lastName;
                    this.email = this.originalDetails.email;
                    this.country = this.originalDetails.country;
                    this.stateProvince = this.originalDetails.stateProvince;
                    this.city = this.originalDetails.city;
                    this.showLocation = this.originalDetails.showLocation;
                    this.website = this.originalDetails.website;
                    this.interests = this.originalDetails.interests;
                }
            }
        },
        mounted() {
            this.firstName = this.details.firstName;
            this.lastName = this.details.lastName;
            this.email = this.details.email;
            this.country = this.details.country;
            this.stateProvince = this.details.stateProvince;
            this.city = this.details.city;
            this.showLocation = this.details.showLocation;
            this.website = this.details.website;
            this.interests = this.details.interests;
            this.avatar = this.details.avatar;
    
            this.originalDetails.firstName = this.firstName;
            this.originalDetails.lastName = this.lastName;
            this.originalDetails.email = this.email;
            this.originalDetails.country = this.country;
            this.originalDetails.stateProvince = this.stateProvince;
            this.originalDetails.city = this.city;
            this.originalDetails.showLocation = this.showLocation;
            this.originalDetails.website = this.website;
            this.originalDetails.interests = this.interests;
        }
    }

</script>
